export default {
  id: 2,
  title: 'ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ',
  points: [
    {
      id: '01',
      title: '1. Термины и определения.',
      points: [
        { id: '001', text: 'Исполнитель – ФотоПочта' },
        {
          id: '002',
          text: 'Мобильное приложение – мобильное приложение ФотоПочта, разработанное для операционных систем iOS и Android и доступное по ссылкам:',
          points: [
            {
              id: '0001',
              links: [0],
              text: ['https://itunes.apple.com/app/id864842646'],
            },
            {
              id: '0002',
              links: [0],
              text: ['https://play.google.com/store/apps/details?id=com.tartugo.FotoPostAppRus'],
            },
          ],
        },
        {
          id: '003',
          text: 'Заказчик/Потребитель/Клиент – физическое или юридическое лицо, имеющее намерение заказать или приобрести фотопродукцию в мобильном приложении ФотоПочта.',
        },
        {
          id: '004',
          text: 'Получатель – физическое лицо, указанное клиентом в качестве получателя заказа.',
        },
        {
          id: '005',
          text: 'Заказ – поручение клиента на изготовление фотопродукции созданное  клиентом через мобильное приложение ФотоПочта.',
        },
        {
          id: '006',
          text: 'Письмо/email – электронное информационное письмо, предназначенное для отправки клиенту.',
        },
      ],
    },
    {
      id: '02',
      title: '2. Общие положения.',
      points: [
        {
          id: '001',
          text: 'Администрация приложения ФотоПочта и сайта оставляет за собой право в любое время изменять, добавлять или удалять пункты настоящего соглашения без уведомления клиента.',
        },
        {
          id: '002',
          text: 'Пользователь несет персональную ответственность за ознакомление с настоящим соглашением и его изменениями.',
        },
        {
          id: '003',
          text: 'Заказывая товары и услуги через мобильное приложение, клиент соглашается с условиями настоящего договора оферты.',
        },
      ],
    },
    {
      id: '03',
      title: '3. Регистрация клиента в мобильном приложении.',
      points: [
        {
          id: '001',
          text: 'Клиент может оформить заказ через мобильное приложение. При оформлении заказа клиент вводит контактную информацию, адрес доставки и банковскую карту для регистрации заказа в мобильном приложении.',
        },
        {
          id: '002',
          text: 'Исполнитель не несет ответственности за точность и правильность информации, предоставляемой клиентом при регистрации.',
        },
        {
          id: '003',
          text: 'Регистрируясь в мобильном приложении, клиент дает согласие на обработку своих персональных данных.',
        },
      ],
    },
    {
      id: '04',
      title: '4. Оплата заказа.',
      points: [
        {
          id: '001',
          text: 'Способы оплаты услуг указаны в мобильном приложении ФотоПочта, а так же могут быть предоставлены по электронной почте по запросу.',
        },
        {
          id: '002',
          text: 'Цены на фотопродукцию указаны в мобильном приложении и сайте исполнителя.',
        },
        {
          id: '003',
          text: 'Цены на сайте и в мобильном приложении могут быть изменены исполнителем в одностороннем порядке.',
        },
        {
          id: '004',
          text: 'Оплата осуществляетя в мобильном приложении и процессинг осуществляет сторонняя компания. Исполнитель не сохраняет данные банковских карт.',
        },
      ],
    },
    {
      id: '05',
      title: '5. Условия оформления и сроки выполнения pаказа.',
      points: [
        {
          id: '001',
          text: 'Заказ может быть оформлен клиентом следующими способами:',
          points: [
            {
              id: '0001',
              text: 'в мобильном приложении ФотоПочта.',
            },
            {
              id: '0002',
              links: [1],
              text: [
                'персональным обращением в службу поддержки клиентов по электронной почте ',
                'support@fotopostapp.com',
                'или социальных сетях.',
              ],
            },
          ],
        },
        {
          id: '002',
          text: 'После оформления заказа клиенту предоставляется информация о статусе выполнения заказа по электронной почте указанной клиентом при оформлении заказа. Изготовление ФотоКниг занимает до 48 часов. Всей остальной продукции до 24 часов. После того как заказ выполнен и отправлен клиент получит дополнительное электронное письмо оповещающее о данном событии.',
        },
        {
          id: '003',
          text: 'Исполнитель вправе аннулировать заказ клиента в случае невозможности оказания услуги. В данной ситуации исполнитель обязан оповестить клиента об этом по электронной почте, указанной при оформлении заказа.',
        },
        {
          id: '004',
          text: 'В случае возникновения вопросов клиент может обратиться к исполнителю по электронной почте – support@fotopostapp.com.',
        },
      ],
    },
    {
      id: '06',
      title: '6. Доставка заказа.',
      points: [
        {
          id: '001',
          text: 'Способы доставки заказов указаны в мобильном приложении, а так же на сайте исполнителя.',
        },
        {
          id: '002',
          text: 'Доставка осуществляется почтой России от 3 до 7 дней, курьером  быстрее. Стоимость доставки почтой России зависит от веса отправления. Мобильное приложение само посчитает и предоставить стоимость при оформлении заказа.',
        },
        {
          id: '003',
          text: 'Служба курьерской доставки несет ответственность за утрату, повреждение, недостачу доставляемых заказов.',
        },
      ],
    },
    {
      id: '07',
      title: '7. Претензии и разрешение споров.',
      points: [
        {
          id: '001',
          text: 'В случае возникновения разногласий или споров между исполнителем и клиентом настоящего договора оферты обязательным условием до обращения в суд является предъявление письменного предложения о добровольном урегулировании спора.',
        },
        {
          id: '002',
          text: 'При невозможности разрешить спор в добровольном порядке любая из сторон вправе обратиться в суд за защитой своих прав, которые предоставлены им действующим законодательством Российской Федерации.',
        },
        {
          id: '003',
          text: 'Исполнитель обязан рассмотреть претензии и ответить клиенту в течении 10 рабочих дней с даты получения претензии.',
        },
      ],
    },
    {
      id: '08',
      title: '8. Гарантии и ответственности.',
      points: [
        {
          id: '001',
          text: 'Клиент гарантирует, что он является единственным законным обладателем фотоматериалов, размещаемых им в мобильном приложении, что владеет исключительными правами на использование, распространение и демонстрацию отправленных фотоматериалов и/или является автором фотоматериалов. В случае предъявления исполнителю третьими лицами любых претензий, связанных с размещением клиентами фотоматериалов, с правами на использование изображения, с нарушением авторских прав или смежных прав третьих лиц, клиент обязуется самостоятельно и за свой счет урегулировать указанные претензии.',
        },
        {
          id: '002',
          text: 'Исполнитель не несет ответственности за содержание и функционирование сайтов своих партнеров.',
        },
        {
          id: '003',
          text: 'Исполнитель гарантирует надлежащее качество выполненного заказа. В случае возникновения брака по своей вине или вине третьих лиц, исполнитель обязуется устранить брак своими силами или найти альтернативное решение сложившейся ситуации.',
        },
      ],
    },
    {
      id: '09',
      title: '9. Защита персональной информации и конфидециальность.',
      points: [
        {
          id: '001',
          text: 'При оформления заказ клиент предоставляет фамилию, имя, адрес электронной почты, телефон, адрес доставки, номер банковской карты для оплаты заказа.',
        },
        {
          id: '002',
          text: 'Исполнитель не несет ответственности за правильность работы платежной системы.',
        },
        {
          id: '003',
          text: 'Исполнитель вправе использовать предоставленную информацию при оформлении заказа для:',
          points: [
            {
              id: '0001',
              text: ['выполнения обязательств перед клиентом'],
            },
            {
              id: '0002',
              text: ['анализа работы мобильного приложения'],
            },
            {
              id: '0003',
              text: ['занесения клиента в клиентскую базу данных'],
            },
          ],
        },
        {
          id: '004',
          text: 'Исполнитель вправе направлять клиенту сообщения рекламно-информационного характера, а так же маркетинговых акций.',
        },
        {
          id: '005',
          text: 'Исполнитель обязуется не разглашать полученную от клиента информацию. Предоставление исполнителем информации агентам и третьим лицам, действующим на основании договора с исполнителем, для исполнения обязательств перед клиентом не является нарушением.',
        },
      ],
    },
    {
      id: '010',
      title: '10. Дополнительные условия.',
      points: [
        {
          id: '001',
          text: 'К отношениям между клиентом и исполнителем применяется право Российской Федерации.',
        },
        {
          id: '002',
          links: [1],
          text: [
            'В случае возникновения вопросов со стороны клиента он должен обратиться в службу поддержки по адресу электронной почты',
            'support@fotopostapp.com',
          ],
        },
        {
          id: '003',
          text: 'Все возникающее споры стороны будут стараться решить путем переговоров.',
        },
      ],
    },
    {
      id: '011',
      title: '11. Контакты',
      points: [
        {
          id: '001',
          text: 'ИП Головчанов Александр Сергеевич',
        },
        {
          id: '002',
          text: 'ИНН: 781422474434',
        },
        {
          id: '003',
          text: 'ОГРНИП: 318784700025071',
        },
        {
          id: '004',
          links: [1],
          text: ['e-mail:', 'support@fotopostapp.com'],
        },
      ],
    },
  ],
};
